import { render, staticRenderFns } from "./product-sales-outbound-detail.vue?vue&type=template&id=b89f8ac0&scoped=true"
import script from "./product-sales-outbound-detail.vue?vue&type=script&lang=js"
export * from "./product-sales-outbound-detail.vue?vue&type=script&lang=js"
import style0 from "./product-sales-outbound-detail.vue?vue&type=style&index=0&id=b89f8ac0&prod&lang=scss&scoped=true"
import style1 from "./product-sales-outbound-detail.vue?vue&type=style&index=1&id=b89f8ac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89f8ac0",
  null
  
)

export default component.exports